











































































import { Component } from "vue-property-decorator";
import QuizPage from "../../components/QuizPage";
import DebugData from "../../components/DebugData.vue";
@Component({
  components: {
    DebugData
  }
})
export default class Region extends QuizPage {
  usaFrameworks = new Set(["23NYCRR500","PCIDSS","GLBA","SOX","HIPAA","CCPA","SOC2",
    "SHIELD","FERPA","BPIA","HB1071","HB1493","TBPL","COPPA","ARPIPA","FIPA","COBIT",
    "ISO27001","NIST-SP-800-53","FISMA","NIST-SP-800-171","CMMC","FEDRAMP","CSACCM"]);

  private created() {
    this.init("region", "/software");
  }

  private updateExclusions() {
    // Update the excluded list to to contain the frameworks from any regions
    // which have not been selected. They will be excluded from the final results.
    let exclude = new Set<string>();
    if (!this.selected.includes("usa")) {
      exclude = this.usaFrameworks;
    }
    if (!this.selected.includes("canada")) {
      exclude.add("PIPEDA");
    }
    if (!this.selected.includes("europe")) {
      exclude.add("GDPR");
    }
    this.$store.commit("excludedFrameworks", exclude);
  }

  private selectCheckboxOverride() {
    this.selectCheckbox();
    this.updateExclusions();
  }

  private goNextOverride() {
    if (this.selected.includes("none")) {
      this.nextPage = "/nota";
    } else if (this.selected.includes("usa")) {
      this.nextPage = "/states";
    }

    this.goNext();
  }
}
